(function() { window.GUID_07e58160_0632_4e33_862b_a127c41f5aae = { getGuid: function() { return "07e58160-0632-4e33-862b-a127c41f5aae"; } }; })();
function getFacebookGraphApiVersion() {
    return fbGraphApiVersion || 'v23.0';
}
window.fbAsyncInit = function () {
    FB.init({
        appId: fbAppId,
        autoLogAppEvents: true,
        xfbml: true,
        version: getFacebookGraphApiVersion(),
    });
    //$('html body').trigger('facebookinitialized');
    console.debug('facebook initialized');
};
//(function (d, s, id) {
//    var js, fjs = d.getElementsByTagName(s)[0];
//    if (d.getElementById(id)) { return; }
//    js = d.createElement(s); js.id = id;
//    js.src = "https://connect.facebook.net/en_US/sdk.js";
//    fjs.parentNode.insertBefore(js, fjs);
//}(document, 'script', 'facebook-jssdk')); 
if (initFacebook) {
    (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
            return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        if (fjs && fjs.parentNode) {
            fjs.parentNode.insertBefore(js, fjs);
        }
        //checkLoginStatus();
    }(document, 'script', 'facebook-jssdk'));
}
function checkLoginStatusCallback(response, action, password, isKiosk) {
    const status = response && response.status;
    console.log("checkLoginStatusCallback : " + status + ' ' + action);
    if (status === 'connected') {
        // the user is logged in and has authenticated your
        // app, and response.authResponse supplies
        // the user's ID, a valid access token, a signed
        // request, and the time the access token
        // and signed request each expire
        //var uid = response.authResponse.userID;
        var accessToken = response.authResponse.accessToken;
        var data = { accessToken: accessToken, returnUrlEncoded: CSParameters.ReturnUrlEncoded, password: password, isKiosk: isKiosk };
        CompuSport.Ajax.Post(CSParameters.BaseUrl + 'Account/' + action, data, function (response) {
            console.log("AjaxPos Completed : " + action + ' ' + response.message + ' ReturnUrl:' + decodeURIComponent(response.returnUrlEncoded));
            if (response.message == 'AlreadyLinked') {
                console.log("replacing url : " + response.returnUrl);
                // On dirait que location.replace ne gere pas bien le cookie d'authentication
                window.location.assign(decodeURIComponent(response.returnUrl));
            }
            else if (response.message == "KioskNotApproved") {
                console.log("KioskNotApproved : " + response.kioskMessage);
                let popup = new CompuSport.Controls.Popup();
                popup.Show(response.kioskMessage, { PopupId: 'AutoLinkFacebookMessage', Buttons: 'Ok' });
            }
            else if (response.message == "KioskApproved") {
                console.log("KioskApproved replacing url : " + response.returnUrl);
                window.location.assign(decodeURIComponent(response.returnUrl));
            }
            else {
                if (response.message != null && response.message != "") {
                    if (response.message != "Error") {
                        let popup = new CompuSport.Controls.Popup();
                        popup.Show(response.message, { PopupId: 'AutoLinkFacebookMessage', Buttons: 'Ok' });
                        popup.OnClosed = function () {
                            window.location.replace(response.returnUrl);
                        };
                    }
                    else {
                        console.log("checkLoginStatusCallback: error");
                    }
                }
                else {
                    if (window.location.search.toLowerCase().indexOf('mobileappevent') != -1) {
                        //Enlever le mobileappevent pour ne pas que l'app le reexecute
                        var params = {};
                        window.location.search.toLowerCase().replace(/[?&]+([^=&]+)=([^&]*)/gi, (str, key, value) => { params[key] = value; return value; });
                        params["mobileappevent"] = '';
                        var url = window.location.pathname + "?" + $.param(params);
                        window.location.replace(url);
                    }
                    else {
                        //Ici, response est undefined, donc, besoin du reload
                        window.location.reload();
                    }
                }
            }
        });
    }
    return true;
}

//# sourceMappingURL=Facebook.js.map
